// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';

const ActionStrip = (props) => {

    return (
        <Link
            to={props.to ? props.to : "#"}
            onClick={props.onClick ? props.onClick : () => {}}
            className={`action-strip-container ${props.className ? props.className : ""}`}
            style={props.style}
        >
            <div className="">
                <h2 className="action-strip-title">
                    {props.title}
                </h2>
            </div>

            <div className={`action-strip-icon-container ${props.iconBgColor}`}>
                {props.icon}
            </div>
        </Link>
    );
}

export default ActionStrip;